"use client";
import { jsx as r } from "react/jsx-runtime";
import { mergeRefs as k } from "../../helpers/mergeRefs.js";
import v from "../../styles/components/InputWrapper.js";
import c from "../../../components/icon/Icon.js";
import x from "@emotion/styled";
import { forwardRef as z, useState as A, useRef as C } from "react";
const H = z(
  ({
    className: f,
    defaultValue: i,
    disabled: a,
    feResetButton: p,
    feSeverity: m,
    feSize: d = "md",
    onChange: o,
    value: R,
    ...g
  }, h) => {
    const [y, s] = A(!1), t = C(null), { "aria-label": B = "Reset", onClick: n } = p ?? {}, l = (e) => {
      s(e !== "");
    }, u = (e, b = "") => {
      o == null || o(e, b), l(e.currentTarget.value);
    }, I = (e) => {
      t.current && (t.current.value = "", t.current.focus()), u(e), n == null || n(e), s(!1);
    }, S = k([h, t]);
    return /* @__PURE__ */ r(
      v,
      {
        className: f,
        "data-comp": "input-search",
        feControlsBefore: /* @__PURE__ */ r(c, { feIcon: "search", feSize: "lg" }),
        feControlsAfter: y && /* @__PURE__ */ r(
          j,
          {
            "aria-label": B,
            disabled: a,
            onClick: (e) => I(e),
            type: "reset",
            children: /* @__PURE__ */ r(c, { feIcon: "close", feSize: "lg" })
          }
        ),
        feSeverity: m,
        feSize: d,
        onClick: () => {
          var e;
          return (e = t.current) == null ? void 0 : e.focus();
        },
        children: /* @__PURE__ */ r(
          "input",
          {
            ...g,
            defaultValue: i,
            disabled: a,
            onChange: (e) => u(e, e.target.value),
            onFocus: (e) => l(e.target.value),
            ref: S,
            type: "search",
            value: R
          }
        )
      }
    );
  }
);
H.displayName = "InputSearch";
const j = x.button`
	line-height: 0;

	&:disabled {
		pointer-events: none;
	}
`;
export {
  H as default
};
